

export default amdIntro;
import getImportSummary from './getImportSummary';
import processName from './processName';
import processIds from './processIds';
function amdIntro(_ref) {
	var name = _ref.name;
	var imports = _ref.imports;
	var hasExports = _ref.hasExports;
	var indentStr = _ref.indentStr;
	var absolutePaths = _ref.absolutePaths;
	var useStrict = _ref.useStrict;

	var _getImportSummary = getImportSummary({ name: name, imports: imports, absolutePaths: absolutePaths });

	var ids = _getImportSummary.ids;
	var names = _getImportSummary.names;

	if (hasExports) {
		ids.unshift('exports');
		names.unshift('exports');
	}

	var intro = '\ndefine(' + processName(name) + processIds(ids) + 'function (' + names.join(', ') + ') {\n\n';

	if (useStrict) {
		intro += indentStr + '\'use strict\';\n\n';
	}

	return intro;
}
//# sourceMappingURL=/www/ESPERANTO/esperanto/.gobble-build/01-babel/1/utils/amd/amdIntro.js.01-babel.map